
import { completeStopFromDashboard } from '@/api';

import { StopCompleteParams } from '@/models/main';
import { JobDetailedData, JobDetailedCompleteData, JobDetailedModalData } from '@/models/jobDetailed';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';

@Component({
  components: {
    Button,
  },
})
export default class StopCompleteDialog extends Vue {
  @Prop(Object) private completeJobData: JobDetailedCompleteData;
  @Prop(Object) private job!: JobDetailedData;
  @Prop({ type: String, default: 'dashboard' }) private context: string;

  private jobModalData: JobDetailedModalData = {
    action: '',
    jobIdShort: -1,
    jobId: -1,
    jobDate: '',
    driver: -1,
    stopNumber: -1,
    position: -1,
    actionText: '',
    podName: '',
    stopText: '',
    stopName: '',
    podNameRequired: false,
    loading: false,
    error: '',
    iconPosition: -1,
  };

  @Watch('completeJobData', { immediate: true })
  private completeJobDataChanged() {
    if (this.job) {
      let actionText = '';
      let podRequired = false;
      if (this.completeJobData.action === 'arrived') {
        actionText = 'arrived to';
      }
      if (this.completeJobData.action === 'departed') {
        actionText = 'departed from';
        if (this.job.require_pod && this.job.main_stop === Number(this.completeJobData.stop)) {
          podRequired = true;
        }
      }
      if (this.completeJobData.action === 'completed') {
        actionText = 'complete';
        if (this.job.require_pod) {
          podRequired = true;
        }
      }

      this.jobModalData = {
        ...this.jobModalData,
        action: this.completeJobData.action,
        jobIdShort: Number(this.job.rockhopper_id),
        jobId: Number(this.job.rockhopper_id),
        jobDate: this.job.rockhopper_date,
        driver: Number(this.job.stops[this.completeJobData.stop - 1]?.driver_is) || 'Not allocated',
        stopNumber: this.completeJobData.stop,
        position: this.completeJobData.stop,
        actionText: actionText,
        stopText: `Stop ${this.completeJobData.stop}`,
        stopName: this.job.stops[this.completeJobData.stop - 1]?.name || '',
        podNameRequired: podRequired,
        error: '',
        iconPosition:
          this.completeJobData.action === 'departed'
            ? 1 + (this.completeJobData.stop - 1) * 2
            : (this.completeJobData.stop - 1) * 2,
      };
    }
  }

  // JOB COMPLETE
  private completeStop(): void {
    const form = this.$refs.form as HTMLFormElement;
    if (form.validate()) {
      this.jobModalData.loading = true;
      const action = this.jobModalData.action === 'completed' ? 'departed' : this.jobModalData.action;
      let params: StopCompleteParams = {
        driver_id: this.jobModalData.driver.toString() === 'Not allocated' ? -1 : this.jobModalData.driver,
        job_id: this.jobModalData.jobIdShort,
        job_date: this.jobModalData.jobDate,
        stop_number: this.jobModalData.stopNumber,
      };

      if (this.jobModalData.podNameRequired) {
        params = { ...params, pod_name: this.jobModalData.podName };
      }

      completeStopFromDashboard(action, params)
        .then(res => {
          if (res?.data.Result === 'Stop sent') {
            this.$emit('fetchData');
          }
        })
        .catch(err => {
          this.jobModalData.error = err;
          this.jobModalData.loading = false;
          return null;
        });
    }
  }
}
